import {
  aromaSkeleton,
  AromaSkeletonVariantProps,
} from "@zenchef/styled-system/recipes";
import { CSSProperties, PropsWithChildren } from "react";
import { HTMLStyledProps } from "@zenchef/styled-system/types";
import { styled } from "@zenchef/styled-system/jsx";

interface SkeletonBaseProps
  extends PropsWithChildren,
    HTMLStyledProps<"div">,
    AromaSkeletonVariantProps {
  isLoaded?: boolean;
}

interface SkeletonShapeProps {
  shape: "shape";
  size?: CSSProperties["width"];
}

interface SkeletonDefaultProps {
  shape?: Omit<AromaSkeletonVariantProps["shape"], "shape">;
  size?: never;
}

export type SkeletonProps = SkeletonBaseProps &
  (SkeletonShapeProps | SkeletonDefaultProps);

const SkeletonElement = styled("div", aromaSkeleton);

const Skeleton = ({
  children,
  isLoaded = false,
  shape,
  ...props
}: SkeletonProps) => {
  if (isLoaded) {
    return children;
  }
  if (shape !== "shape") {
    return <SkeletonElement shape={shape} {...props} />;
  }

  const { size, ...rest } = props;

  return (
    <SkeletonElement
      shape={shape}
      style={
        {
          "--skeleton-size": size,
        } as CSSProperties
      }
      {...rest}
    >
      <svg viewBox="0 0 40 40">
        <defs>
          <clipPath
            id="clipShape"
            transform="scale(0.025, 0.025)"
            clipPathUnits="objectBoundingBox"
          >
            <path d="M40 20C40 36.0457 36.0457 40 20 40C3.95431 40 0 36.0457 0 20C0 3.95431 3.95431 0 20 0C36.0457 0 40 3.95431 40 20Z" />
          </clipPath>
        </defs>
      </svg>
    </SkeletonElement>
  );
};

export default Skeleton;
